import { Injectable } from '@angular/core';

import { BaseStorage } from '../../core/abstractions/base.storage';
import { StorageTypeEnum } from '../../models/enums/storage-type.enum';
import { OptionalType } from '../../models/types/optional.type';

@Injectable({
    providedIn: 'root'
})
export class AppSessionStorage extends BaseStorage {
    private currentContext = 'currentContext';
    private notLoggedRedirectUrl = 'notLoggedRedirectUrl';

    constructor() {
        super('app', StorageTypeEnum.Session);
    }

    saveCurrentContext(context: string): void {
        this.save(context, this.currentContext);
    }

    getCurrentContext(): string {
        return this.get<string>(this.currentContext) ?? '';
    }

    saveNotLoggedRedirectUrl(redirectUrl?: string): void {
        this.save(redirectUrl, this.notLoggedRedirectUrl);
    }

    getNotLoggedRedirectUrl(): OptionalType<string> {
        return this.get<string>(this.notLoggedRedirectUrl);
    }
}
